export const platformOptions = [
  "github",
  "linkedin",
  "instagram",
  "facebook",
  "twitter",
  "reddit",
  "website",
  "resume",
];

export const tags = [
  "Python",
  "Java",
  "JavaScript",
  "C++",
  "C#",
  "Swift",
  "PHP",
  "Ruby",
  "Go",
  "Kotlin",
  "React",
  "Angular",
  "Vue.js",
  "Django",
  "Ruby on Rails",
  "Express.js",
  "Laravel",
  "Spring",
  "ASP.NET",
  "Flask",
  "Node.js",
  "Android",
  "iOS",
  "React Native",
  "Flutter",
  "Xamarin",
  "Ionic",
  "PhoneGap",
  "Cordova",
  "Unity",
  "Unreal Engine",
  "MySQL",
  "PostgreSQL",
  "MongoDB",
  "Oracle",
  "Microsoft SQL Server",
  "SQLite",
  "Cassandra",
  "Redis",
  "CouchDB",
  "Firebase",
  "TensorFlow",
  "PyTorch",
  "Keras",
  "Scikit-learn",
  "Numpy",
  "Pandas",
  "OpenCV",
  "Caffe",
  "Theano",
  "MXNet",
  "TypeScript",
  "Rust",
  "Scala",
  "R",
  "Dart",
  "Lua",
  "Julia",
  "Perl",
  "Erlang",
  "F#",
  "Next.js",
  "Meteor",
  "Ember.js",
  "Sinatra",
  "Hapi.js",
  "Adonis.js",
  "Nest.js",
  "Sails.js",
  "Xamarin.Forms",
  "Xamarin.iOS",
  "Xamarin.Android",
  "NativeScript",
  "Marmalade",
  "PhoneGap Build",
  "Corona SDK",
  "GameMaker Studio",
  "Godot",
  "Construct 2",
  "Amazon RDS",
  "Amazon DynamoDB",
  "Amazon Redshift",
  "Amazon DocumentDB",
  "Couchbase",
  "RavenDB",
  "Firebird",
  "MariaDB",
  "Memcached",
  "Apache Cassandra",
  "Amazon Elastic Compute Cloud (EC2)",
  "Amazon Simple Storage Service (S3)",
  "Amazon Relational Database Service (RDS)",
  "Amazon Elastic Container Service (ECS)",
  "Amazon Lambda",
  "Amazon Elastic Kubernetes Service (EKS)",
  "Google Compute Engine (GCE)",
  "Google Cloud Storage (GCS)",
  "Google Cloud SQL",
  "Microsoft Azure Functions",
  "Keras-TensorFlow",
  "SciPy",
  "PyTorch Lightning",
  "Jupyter Notebook",
  "OpenAI",
  "Microsoft Cognitive Toolkit (CNTK)",
  "Apache Mahout",
  "Deeplearning4j",
  "H2O.ai",
  "NoSQL",
  "Redux",
  "Socket.IO",
  "Node.js",
  "NPM",
  "Express.js",
  "Socket.io",
  "Koa.js",
  "Next.js",
  "Meteor",
  "Ember.js",
  "Hapi.js",
  "Adonis.js",
  "Nest.js",
  "Sails.js",
];
